import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'device_mng',
  components: {
    labSel: function labSel() {
      return import('../org/lab_sel.vue');
    },
    areaSel: function areaSel() {
      return import('../org/lab_area_sel.vue');
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '采集器管理',
        addFunName: 'deviceAdd',
        modifyFunName: 'deviceModify',
        queryFunName: 'deviceQueryJoinLab',
        detailFunName: 'deviceDetail',
        delFunName: 'deviceDel',
        unbindFunName: 'deviceUnbind',
        dicTreeFunName: 'dictionaryCache'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'online_state,id'
      },
      formData: {
        comModel: 'DTU',
        interactiveModel: 'Self_Report',
        offlineThreshold: 600
      },
      rules: {
        deviceName: [{
          required: true,
          message: '请输入设备名称',
          trigger: 'blur'
        }],
        id: [{
          required: true,
          message: '请输入设备编号',
          trigger: 'blur'
        }],
        deviceType: [{
          required: true,
          message: '请选择设备类型',
          trigger: 'blur'
        }],
        interactiveModel: [{
          required: true,
          message: '请选择通信模式',
          trigger: 'blur'
        }],
        comModel: [{
          required: true,
          message: '请选择通讯模式',
          trigger: 'blur'
        }],
        labId: [{
          required: true,
          message: '请选择企业机构',
          trigger: 'blur'
        }]
        // , areaId: [
        //   { required: true, message: '请选择养殖区域', trigger: 'blur' }
        // ]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '120px',
      emptyFormData: {},
      lab_show: false,
      area_show: false,
      dicData: {
        typeUpperCode: 'iot_product_type',
        configTypes: [],
        configTypeOptions: {}
      },
      isBusiness: localStorage.getItem('accountCategory') === 'Business' ? true : false
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.typeUpperCode).then(function (res) {
      if (res.data) {
        _this.dicData.configTypes = res.data;
        var _iterator = _createForOfIteratorHelper(res.data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _this.dicData.configTypeOptions[item.code] = item.name;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        _this.emptyFormData = JSON.parse(JSON.stringify(_this.formData));
        _this.query();
      }
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'bind':
          // 绑定
          this.bind(command.row);
          break;
        case 'unbind':
          // 解绑
          this.unbind(command.row);
          break;
        case 'del':
          // 删除
          this.del(command.row.id);
          break;
        case 'askCmd':
          // 询问命令
          this.askCmd(command.row);
          break;
        case 'item':
          // 检测参数
          this.item(command.row);
          break;
        case 'warn':
          // 告警规则
          this.warn(command.row);
          break;
        case 'logs':
          // 设备日志
          this.logs(command.row);
          break;
        case 'edit':
          // 设备编辑
          this.edit(command.row);
          break;
      }
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.initFormData(this.emptyFormData);
      this.editDialogShow = true;
    },
    edit: function edit(data) {
      this.initFormData(data);
      this.editDialogTitle = this.pageConfig.editPageName + '维护';
      this.editDialogShow = true;
    },
    getLocation: function getLocation(e) {
      this.markLocation = e.point;
      this.$set(this.formData, 'lat', e.point.lat);
      this.$set(this.formData, 'lng', e.point.lng);
    } // 选择企业
    ,
    labSel: function labSel(data) {
      if (data) {
        this.formData.labId = data.id;
        this.$set(this.formData, 'labName', data.name);
        this.$set(this.formData, 'areaId', '');
        this.$set(this.formData, 'areaName', '');
      }
      this.lab_show = false;
    } // 选择养殖区域
    ,
    areaSel: function areaSel(data) {
      if (data) {
        this.$set(this.formData, 'areaId', data.id);
        this.$set(this.formData, 'areaName', data.name);
      }
      this.area_show = false;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this2.formData.deviceIcon = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.deviceIcon);
    },
    removeFile: function removeFile() {
      this.formData.deviceIcon = '';
    },
    del: function del(id) {
      var _this3 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this3.$api[_this3.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this3.$message.success('删除成功');
            _this3.query();
          } else {
            _this3.$message.error('删除失败');
          }
        });
      });
    } // 绑定企业
    ,
    bind: function bind(data) {
      this.initFormData(data);
      this.bindShow = true;
    },
    bindSel: function bindSel(val) {
      if (val) {
        this.query();
      }
      this.bindShow = false;
      this.initFormData(this.emptyFormData);
    } // 解绑
    ,
    unbind: function unbind(data) {
      var _this4 = this;
      this.$api[this.pageConfig.unbindFunName](data.id).then(function (res) {
        if (res.data) {
          _this4.$message.success('解绑成功');
          _this4.query();
        } else {
          _this4.$message.error('解绑失败');
        }
      });
    } // 参数
    ,
    item: function item(course) {
      this.$emit('child-go', course, 'deviceItem');
    } // 告警
    ,
    warn: function warn(course) {
      this.$emit('child-go', course, 'warn');
    } // 历史记录
    ,
    history: function history(course) {
      this.$emit('child-go', course, 'history');
    } // 告警历史
    ,
    warnHistory: function warnHistory(course) {
      this.$emit('child-go', course, 'warnHistory');
    } // 历史分析
    ,
    analysis: function analysis(course) {
      this.$emit('child-go', course, 'analysis');
    } // 询问命令
    ,
    askCmd: function askCmd(course) {
      this.$emit('child-go', course, 'askCmd');
    } // 设备日志
    ,
    logs: function logs(course) {
      this.$emit('child-go', course, 'logs');
    },
    query: function query() {
      var _this5 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this5.tableData = res.data || [];
        _this5.totalCount = res.count;
        _this5.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this6 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this6.formData.createTime) {
            _this6.$api[_this6.pageConfig.modifyFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('编辑成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('编辑失败');
              }
            });
          } else {
            _this6.$api[_this6.pageConfig.addFunName](_this6.saveFormDataProcess(_this6.formData)).then(function (res) {
              if (res.data) {
                _this6.$message.success('新增成功');
                _this6.initFormData(_this6.emptyFormData);
                _this6.editDialogShow = false;
                _this6.query();
              } else {
                _this6.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'online_state, id';
      this.query();
    }
  }
};